<template>
  <section class="world-background-green">
    <cards-roulette :options="options" :type="'fundraising_program_types'" />
  </section>
</template>

<script>
import FundraisingProgramTypes from '@/constants/fundraising_program_types.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'


export default {
  mixins: [OnBoardStepMixin],
  components: { CardsRoulette },
  data() {
    return {
      options: []
    }
  },
  mounted() {
    const capitalProgramType = this.$store.state.onBoard.neofintech.phase1
      .capitalProgramTypes[0]
    this.options = FundraisingProgramTypes.filter(function(item) {
      return item.parents.includes(capitalProgramType)
    })
  }
}
</script>
